import { Controller } from "@hotwired/stimulus";

/**
 * GO4S Design System — repli/dépli générique (ex. raisonnement IA).
 * Plusieurs `content` basculent ensemble : une lecture cède la place à son
 * formulaire, et inversement.
 */
export default class extends Controller {
  static targets = ["content"];

  toggle() {
    this.contentTargets.forEach((content) => { content.hidden = !content.hidden; });
  }
}
